// extracted by mini-css-extract-plugin
module.exports = {"content":"IntentionBack_content_3L8nn","greetText":"IntentionBack_greetText_BMXgl","options":"IntentionBack_options_AfLZF","button":"IntentionBack_button_1isgF"};